import React from 'react';
import { Link } from 'react-router-dom';
import { TiArrowBack } from "react-icons/ti";

const NotFound: React.FC = () => {
    return (
        <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <h2>404 - Page Not Found</h2>
            <p>Diese Seite existiert nicht</p>
            <Link to="/" style={{ color: 'mediumblue', textDecoration: 'none', fontSize: '18px' }}>
                <TiArrowBack style={{ marginBottom: "4px" }} /> Zurück zur Startseite
            </Link>
        </div>
    );
};

export default NotFound;